import './CrossProductsCarousel.scss';

import { Image } from 'antd';
import Carousel, { CarouselRef } from 'antd/es/carousel';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

interface Props {
    veri: any;
}

const CrossProductsCarousel = ({ veri }: Props) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [previewVisible, setPreviewVisible] = useState<boolean>(false);
    const carouselRef = useRef<CarouselRef>(null);
    const classes = classNames('cross-products-carousel');

    useEffect(() => {
        if (carouselRef.current) {
            carouselRef.current.goTo(0);
        }
    }, [veri]);

    if (!veri || !veri.urun) {
        return null;
    }

    const resimlerArr: string[] = Array.isArray(veri.urun.resimler) ? veri.urun.resimler.filter(Boolean) : [];
    const images: string[] = resimlerArr.length > 0
        ? resimlerArr
        : veri.urun.resim
            ? [veri.urun.resim]
            : [];

    if (images.length === 0) {
        return null;
    }

    const handleThumbnailClick = (index: number) => {
        setActiveIndex(index);
        if (carouselRef.current) {
            carouselRef.current.goTo(index);
        }
    };

    const handleCarouselChange = (currentIndex: number) => {
        setActiveIndex(currentIndex);
    };

    return (
        <div className={classes}>
            {/*
              Image.PreviewGroup tüm Carousel görsellerini bir grup olarak tanımlar.
              infinite={false} ile Carousel, slick klonlama yapmaz — grup indeksleri doğru kalır.
              accessibility={!previewVisible} ile preview açıkken Carousel ok tuşlarını yoksayar.
            */}
            <Image.PreviewGroup
                preview={{
                    onVisibleChange: (visible) => setPreviewVisible(visible),
                }}
            >
                <Carousel
                    className="cross-products-carousel carousel-container"
                    draggable
                    dots={false}
                    infinite={false}
                    ref={carouselRef}
                    afterChange={handleCarouselChange}
                    accessibility={!previewVisible}
                >
                    {images.map((resim: string, index: number) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                            <Image
                                className="image-still"
                                src={resim || process.env.NX_NO_IMAGE_URL}
                                alt="ürün detay"
                                onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                                    const target = e.target as HTMLImageElement;
                                    target.src = process.env.NX_NO_IMAGE_URL!;
                                }}
                            />
                        </div>
                    ))}
                </Carousel>
            </Image.PreviewGroup>
            <div className="custom-cross-product-indicators">
                {images.map((image, index) => (
                    <img
                        key={index}
                        width={50}
                        height={50}
                        className={`${index === activeIndex ? 'active' : 'non-active'}`}
                        src={image || process.env.NX_NO_IMAGE_URL}
                        alt="ürün detay"
                        onClick={() => handleThumbnailClick(index)}
                        onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                            const target = e.target as HTMLImageElement;
                            target.src = process.env.NX_NO_IMAGE_URL!;
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default CrossProductsCarousel;
